// extracted by mini-css-extract-plugin
export default {"root":"app_root__kzkKE","body":"app_body__6LxcF"};